// TODO: Unit tests

const findPageComponentByName = (pageComponents, name) =>
  pageComponents.find(component => component.__typename === name);

export default findPageComponentByName;
